export default {
    buttons: {
        back: "Voltar",
        next: "Próximo",
        submit: "Enviar"
    }
}